export { default as UploadImg } from './upload-img/UploadImg.jsx';
export { default as UploadImgList } from './upload-img-list/UploadImgList';
export { default as UploadVideo } from './upload-video/UploadVideo';
export { default as Checkbox } from './checkbox/Checkbox';
export { default as BgImg } from './bg-img/BgImg';
